import { __decorate, __metadata } from "tslib";
import { Brands } from '@cbbt/itf-onboarding-common';
import { BaseMessage, Field } from '@cbbt/lib-interface';
import { JourneyId } from '../enums/JourneyId.js';
class GenerateJWTRequest extends BaseMessage {
    journeyId;
    brand;
    caseReference;
}
__decorate([
    Field.enum({
        enum: JourneyId,
        description: 'journey id to pick the process code',
        required: true,
    }),
    __metadata("design:type", String)
], GenerateJWTRequest.prototype, "journeyId", void 0);
__decorate([
    Field.enum({
        enum: Brands,
        description: 'brand to be used for external token',
        required: true,
    }),
    __metadata("design:type", String)
], GenerateJWTRequest.prototype, "brand", void 0);
__decorate([
    Field.string({
        required: true,
        description: 'case reference number for external token',
        minLength: 1,
    }),
    __metadata("design:type", String)
], GenerateJWTRequest.prototype, "caseReference", void 0);
export { GenerateJWTRequest };
//# sourceMappingURL=GenerateJWTRequest.js.map